import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../ui/Dialog/DialogActions";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import MuiTreeView from "@material-ui/lab/TreeView";
import MuiTreeItem from "@material-ui/lab/TreeItem";

import { editDepartments, getDepartments } from "../../../../store/actions";
import { getOrgDepartments } from "../../../../../Organizations/store/actions";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "360px",
    boxSizing: "border-box"
  },
  label: {
    fontSize: 10
  }
});

const TreeView = withStyles(() => ({
  root: {
    borderColor: "#CACCD1",
    borderWidth: "1px 1px 0px 1px",
    borderStyle: "solid"
  }
}))(MuiTreeView);

const useTreeItemStyles = makeStyles(theme => ({
  root: {
    boxSizing: "border-box",
    padding: "0 18px",
    borderBottom: "1px solid #CACCD1",
    "& .MuiTreeItem-content:hover": {
      backgroundColor: "transparent"
    }
  },
  labelRoot: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  checkbox: {
    "&.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  }
}));

const TreeItem = ({ labelText, onChange, index, checked, ...rest }) => {
  const classes = useTreeItemStyles();

  return (
    <MuiTreeItem
      label={
        <div className={classes.labelRoot}>
          <Typography variant="body2">{labelText}</Typography>
          <Checkbox
            className={classes.checkbox}
            onChange={(_, val) => onChange(index, val)}
            checked={checked}
            value="checked"
            color="primary"
          />
        </div>
      }
      classes={{
        root: classes.root
      }}
      {...rest}
    />
  );
};

const EMPTY_DEPS_ARRAY = [];

const DepartmentsModal = ({
  open,
  handleClose,
  classes,
  history,
  fullInfo,
  getOrgDepartments,
  loadFacilityDepartments,
  editDepartments,
  departments,
  selectedDepartments
}) => {
  const [deps, setDeps] = React.useState([]);
  const [orgId, setOrgId] = React.useState((fullInfo && fullInfo.info) ? fullInfo.info.orgId : -1);

  const onConfirm = () => {
    if (fullInfo && fullInfo.info && fullInfo.info.id) {
      editDepartments(fullInfo.info.id, deps);
      loadFacilityDepartments(fullInfo.info.id);
      onClose();
    }
  };

  const onClose = () => {
    handleClose();
  };

  React.useEffect(() => {
    if (orgId && orgId !== -1) {
      getOrgDepartments(orgId);
    }
  }, [getOrgDepartments]);

  const availableDeps = (departments && orgId && orgId !== -1) ?
    departments : EMPTY_DEPS_ARRAY;

  React.useEffect(() => {
    if (availableDeps && selectedDepartments) {
      const checkedDeps = availableDeps.map(dep => ({
        ...dep,
        checked: selectedDepartments.some(({ id }) => id === dep.id)
      }));
      setDeps(checkedDeps);
    }
  }, [availableDeps, selectedDepartments]);

  const onCheck = (index, checked) => {
    const newDeps = [...deps];
    newDeps[index].checked = !!checked;
    setDeps(newDeps);
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Подразделения в здании</DialogTitle>
        <DialogContent>
          <TreeView
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
          >
            {deps &&
              deps.map(({ id, name, checked }, index) => (
                <TreeItem
                  key={id}
                  nodeId={id.toString()}
                  checked={checked}
                  labelText={name}
                  onChange={onCheck}
                  index={index}
                />
              ))}
          </TreeView>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button onClick={() => onConfirm()} color="green">
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  fullInfo: state.facilities.facilityFullInfo,
  departments: state.organizations.departmentList,
  selectedDepartments: state.facilities.departments
});

const mapDispatchToProps = dispatch => ({
  getOrgDepartments: orgId => dispatch(getOrgDepartments(orgId)),
  loadFacilityDepartments: id => dispatch(getDepartments(id)),
  editDepartments: (id, deps) => dispatch(editDepartments(id, deps))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(DepartmentsModal)));
